import React, { createElement } from 'react';
import './index.css';
import { createRoot } from 'react-dom/client';
import { App } from './App';
// Set global metadata as early as possible (before React mounts) for SEO and Open Graph
document.title = 'Maestro Connect | Professional Tools for Music Teachers';
const setMeta = (attr: string, key: string, content: string) => {
  let el = document.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.content = content;
};
setMeta('name', 'description', 'Manage lessons, students, scheduling, and growth — all in one place. Built specifically for private music educators.');
setMeta('property', 'og:title', 'Maestro Connect | Professional Tools for Music Teachers');
setMeta('property', 'og:description', 'Manage lessons, students, scheduling, and growth — all in one place. Built specifically for private music educators.');
setMeta('property', 'og:type', 'website');
setMeta('property', 'og:url', 'https://maestroconnect.io/');
setMeta('property', 'og:image', 'https://uploadthingy.s3.us-west-1.amazonaws.com/1YYDABxxgC3iLBdkcPAnB8/Pianist.jpg');
setMeta('property', 'og:image:width', '1200');
setMeta('property', 'og:image:height', '630');
// Ensure mobile pinch zoom works normally in preview
setMeta('name', 'viewport', 'width=device-width, initial-scale=1.0');
const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container);
root.render(<React.StrictMode data-id="element-12547">
    <App data-id="element-12548" />
  </React.StrictMode>);